import React from 'react';
import AllRoute from './routes';


const App = () => {

  return (
    <div className="App" id='scrool'>
      <AllRoute />
    </div>
  );
}

export default App;
